/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import React from "react";
import accessibilityStyles from "../Accessibility.css";
import { FIELD_TYPE } from "javascript/jsEngine/constants/enums";
import { ACCESSIBILITY_FORM_NODE_TITLE } from "constants/enums";

export const AccessibleTextBoxNode = ({ annotInfo: { value, fieldType, tooltip }, style }) => (
  <p tabIndex="-1" className={accessibilityStyles.textFieldNode} style={style}>
    {fieldType === FIELD_TYPE.PASSWORD
      ? `${tooltip}, ${ACCESSIBILITY_FORM_NODE_TITLE.PASSWORD} ${ACCESSIBILITY_FORM_NODE_TITLE.READONLY}`
      : `${tooltip}, ${ACCESSIBILITY_FORM_NODE_TITLE.TEXTBOX} ${ACCESSIBILITY_FORM_NODE_TITLE.READONLY}, ${value}`}
  </p>
);
